export default __webpack_public_path__ + "static/media/win.df8c272a.mp3";